import React, { useState, useEffect } from "react";
import UploadedBanner from "../../../components/common/UploadBanner";
import { InputField } from "../../../components/common/InputField";
import { SelectField } from "../../../components/common/SelectField";
import ModalHeader from "../../../components/ui/ModalHeader";
import { MeditationSessionInput } from "../../../config/recipieMotivationalManager";
import { useMediaStore } from "../../../store";
import { SearchableSelectField } from "../../../components/common/SearchableSelectField";


const AddMeditationSessionOverview = ({
                                        jsonData,
                                        onClose,
                                        onSubmit,
                                        selectedPlanId,
                                      }) => {
  const {
    name,
    description,
    time_allotted_minutes,
    skill_level,
    cultural_background_info,
    recommended_time_of_day,
    benefits,
    tags,
    cover_image_url,
  } = jsonData?.meditation_session || {};

  const [formData, setFormData] = useState({});
  useEffect(() => {
    setFormData({
      name: name || "",
      type: "Mindfulness",
      time_allotted_minutes: time_allotted_minutes || "",
      description: description || "",
      cultural_background_info: cultural_background_info || "",
      benefits: benefits?.join(", ") || "",
      skill_level: skill_level || "",
      recommended_time_of_day: recommended_time_of_day || "",
      tags: tags?.join(", ") || "",
      cover_image_url : cover_image_url || ''
    });
  }, [benefits, cover_image_url, cultural_background_info, description, jsonData, name, recommended_time_of_day, skill_level, tags, time_allotted_minutes]);
  const { imageUrls } = useMediaStore();


  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = () => {
    onSubmit(formData);
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{ display: "block" }}
        aria-modal="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <ModalHeader onClose={onClose} />
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-2"></div>
                <div className="col-sm-6">
                  <h5>MEDITATION SESSION OVERVIEW</h5>
                  <hr />
                  {MeditationSessionInput?.reduce((rows, field, index) => {
                    if (field.type === "textarea") {
                      rows.push([field]);
                    } else {
                      const isEvenIndex = index % 2 === 0;
                      if (isEvenIndex) {
                        rows.push([field]);
                      } else {
                        rows[rows.length - 1].push(field);
                      }
                    }
                    return rows;
                  }, []).map((row, rowIndex) => (
                    <div className="row mb-3" key={rowIndex}>
                      {row.map((field, index) => (
                        <div
                          className={
                            field.type === "textarea" ? "col-12" : "col-6"
                          }
                          key={index}
                        >
                          {field.type === "select" ? (
                            <SelectField
                              label={field.label}
                              id={field.id}
                              options={field.options}
                              value={formData[field.valueKey] || ""}
                              onChange={(e) =>
                                handleChange(field.valueKey, e.target.value)
                              }
                              disabled={true}
                            />
                          ) : field.type === "textarea" ? (
                            <div className="mb-3">
                              <label htmlFor={field.id} className="form-label">
                                {field.label}
                              </label>
                              <textarea
                                className="form-control"
                                id={field.id}
                                rows={field.rows}
                                value={formData[field.valueKey] || ""}
                                onChange={(e) =>
                                  handleChange(field.valueKey, e.target.value)
                                }
                                disabled={true}
                              />
                            </div>
                          ) : (
                            <InputField
                              label={field.label}
                              type={field.type}
                              id={field.id}
                              value={formData[field.valueKey] || ""}
                              onChange={(e) =>
                                handleChange(field.valueKey, e.target.value)
                              }
                              disabled={true}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
                  <div className="row mb-3">
                    <div className="col-12">
                      <SearchableSelectField
                        key={'image'}
                        label={'Image Name'}
                        id={'bannerImageUrl'}
                        options={imageUrls}
                        value={formData.cover_image_url || ""}
                        onChange={(value) =>
                          handleChange("cover_image_url", value)
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-4">
                  <UploadedBanner
                    defaultImage={formData.cover_image_url}
                  />
                </div>
              </div>
            </div>
            {!selectedPlanId ? (
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  Save
                </button>
              </div>
            ) : (
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
};

export default AddMeditationSessionOverview;
